import React from 'react';

// Общие элементы инструкции по созданию событий: скриншот, номер метки,
// заметка, оглавление. Скриншоты — public/guides/events/<lang>/<name>.webp

export const Shot = ({ lang, name, alt, caption }) => (
  <figure className="guide-shot">
    <img src={`/guides/events/${lang}/${name}.webp`} alt={alt} loading="lazy" />
    {caption && <figcaption>{caption}</figcaption>}
  </figure>
);

export const Num = ({ children }) => <span className="guide-num">{children}</span>;

export const Note = ({ kind = 'info', children }) => (
  <div className={`guide-note guide-note-${kind}`}>{children}</div>
);

export const Toc = ({ title, items }) => (
  <nav className="guide-toc" aria-label={title}>
    <p className="guide-toc-title">{title}</p>
    <ol>
      {items.map(([id, label]) => (
        <li key={id}><a href={`#${id}`}>{label}</a></li>
      ))}
    </ol>
  </nav>
);
